import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import SystemSettingsAndConfiguration from './pages/system-settings-and-configuration';
import EmployeeShiftCalendar from './pages/employee-shift-calendar';
import MyAssignedShifts from './pages/my-assigned-shifts';
import GoogleOAuthLogin from './pages/google-o-auth-login';
import AvailableShiftsBooking from './pages/available-shifts-booking';
import AdminScheduleManagementDashboard from './pages/admin-schedule-management-dashboard';
import PersonalAvailabilityManagement from './pages/personal-availability-management';
import ShiftCreationAndEditing from './pages/shift-creation-and-editing';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<EmployeeShiftCalendar />} />
        <Route path="/system-settings-and-configuration" element={<SystemSettingsAndConfiguration />} />
        <Route path="/employee-shift-calendar" element={<EmployeeShiftCalendar />} />
        <Route path="/my-assigned-shifts" element={<MyAssignedShifts />} />
        <Route path="/google-o-auth-login" element={<GoogleOAuthLogin />} />
        <Route path="/available-shifts-booking" element={<AvailableShiftsBooking />} />
        <Route path="/admin-schedule-management-dashboard" element={<AdminScheduleManagementDashboard />} />
        <Route path="/personal-availability-management" element={<PersonalAvailabilityManagement />} />
        <Route path="/shift-creation-and-editing" element={<ShiftCreationAndEditing />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
